import { render, staticRenderFns } from "./CreatorShopSearch.vue?vue&type=template&id=2ab00afc&scoped=true"
import script from "./CreatorShopSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreatorShopSearch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreatorShopSearch.vue?vue&type=style&index=0&id=2ab00afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab00afc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CTextField: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CTextField/CTextField.vue').default})
